import React, { useState } from "react";
import poster from "../assets/poster/Poster.png";

import mainpaper from "../assets/paper/paper.pdf";
import supplemental from "../assets/paper/supplementary.pdf"; 



const Navbar = () => {
  const buttonStyle = {
    backgroundColor: 'black',
    color: 'white',
    borderRadius: '50px',
    padding: '10px 20px',
    border: 'none',
    cursor: 'pointer',
    textDecoration: 'none',
    marginRight: '10px', // Adjust as needed
  };

  const lineStyle = {
    width: '100%',
    height: '2px',
    backgroundColor: 'black',
    marginBottom: '10px', // Adjust as needed
  };

  return (
    <nav
      className="navbar navbar-expand-lg navbar-light"
      style={{
        backgroundColor: "#ffffff",
        padding: "2rem 1rem", // Increased padding for a larger navbar
      }}
    >
      <div className="container d-flex flex-column align-items-center">
        <div className="d-flex justify-content-center w-100">
          <a
            className="navbar-brand nav-link-item head-name text-center"
            href=""
            style={{ color: "black", fontFamily: "Times New Roman", fontSize: "2rem", fontWeight: "bold" }} // Changed font family, color, and increased font size
          >
            FlowBench: A Large Scale Geometry-aware SciML Dataset for Transport Phenomena
          </a>
        </div>
        <div className="d-flex justify-content-center w-100">
          <div className="text-center" style={{ fontSize: "1rem", marginTop: "1rem" }}>
            <p>
              <span style={{ color: "#1a0dab", fontWeight: "bold" }}>
                <a href="https://www.linkedin.com/in/ronaktali/">Ronak Tali</a><sup>1*</sup>,
                <a href="https://www.linkedin.com/in/alirabeh/">Ali Rabeh</a><sup>1*</sup>,
                <a href="https://www.linkedin.com/in/ychenghau/">Cheng-Hau Yang</a><sup>1*</sup>,
                <a href="https://www.linkedin.com/in/mehdi-shadkhah/">Mehdi Shadkhah</a><sup>1</sup>,
                <a href="https://www.linkedin.com/in/samundra-karki-1aa8ab176/">Samundra Karki</a><sup>1</sup>,
                <a href="https://www.linkedin.com/in/abhisekupadhyaya/">Abhisek Upadhyaya</a><sup>2</sup>,
                <a href="https://www.linkedin.com/in/s-narayanan/ ">Suriya Dhakshinamoorthy</a><sup>1</sup>,
                <a href="https://scholar.google.com/citations?user=Xo2rp2EAAAAJ&hl=en&oi=sra">Marjan Saadati</a><sup>1</sup>,
                <a href="https://scholar.google.com/citations?user=-rmRjqIAAAAJ&hl=en&oi=ao">Soumik Sarkar</a><sup>1</sup>,
                <a href="https://scholar.google.com/citations?user=iVTMSxoAAAAJ&hl=en&oi=ao">Adarsh Krishnamurthy</a><sup>1</sup>,
                <a href="https://scholar.google.com/citations?user=eJAV17IAAAAJ&hl=en&oi=ao">Chinmay Hegde</a><sup>2</sup>,
                <a href="https://scholar.google.com/citations?user=GNuXi6oAAAAJ&hl=en&oi=ao">Aditya Balu</a><sup>1</sup>,
                <a href="https://www.me.iastate.edu/bglab/">Baskar Ganapathysubramanian</a><sup>1</sup>
              </span>
            </p>
            <p>
              <span style={{ color: "#5f6368" }}><sup>1</sup>Iowa State University, <sup>2</sup>New York University</span>
            </p>
            <img src={poster} alt="Poster" style={{ maxWidth: "50%", marginTop: "0.8rem" }} />
          </div>
        </div>
        <hr style={lineStyle} />
        <div className="black-box d-flex justify-content-between w-100 mt-4">
          <button className="nav-btn" style={buttonStyle}><a href={mainpaper} className="nav-link" target="_blank" rel="noopener noreferrer">Paper</a></button>
          <button className="nav-btn" style={buttonStyle}><a href={supplemental} className="nav-link" target="_blank" rel="noopener noreferrer">Supplemental</a></button>
          <button className="nav-btn" style={buttonStyle}><a href="https://github.com/baskargroup/flowbench-tools" className="nav-link" target="_blank" rel="noopener noreferrer">Code</a></button>
          <button className="nav-btn" style={buttonStyle}><a href="https://huggingface.co/datasets/BGLab/FlowBench/tree/main" className="nav-link" target="_blank" rel="noopener noreferrer">Data</a></button>
        </div>
      </div>
    </nav>
  );
};

const About = () => {
  const [selectedDataset, setSelectedDataset] = useState("");
  const [description, setDescription] = useState("");
  const [metadata, setMetadata] = useState({});

  const datasets = {
    "LDC_2D": "2D LDC dataset",
    "LDC_3D": "3D LDC dataset",
  };

  const metadataInfo = {
    "LDC_2D": {
      description: "2D LDC dataset",
      size: "500 MB",
      samples: "2000",
      resolution: "128x128",
      variables: "u,p,v,T"
    },
    "LDC_3D": {
      description: "3D LDC dataset",
      size: "1 GB",
      samples: "2000",
      resolution: "256x256",
      variables: "u,p,v,T"
    },
  };

  const handleDatasetChange = (e) => {
    const datasetName = e.target.value;
    setSelectedDataset(datasetName);
    setDescription(datasets[datasetName] || "");
    setMetadata(metadataInfo[datasetName] || {});
  };

  return (
    <section className="pt-2">
      <Navbar />
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center">
            <div style={{ backgroundColor: "#e0e0e0", color: "#000", padding: "1rem", borderRadius: "0.5rem" }}>
              <span className="greeting" style={{ fontSize: "2rem" }}>Abstract</span>
              <p style={{ color: "#540", fontSize: "0.9rem", textAlign: "justify", textAlignLast: "center" }}>
                Simulating fluid flow around arbitrary shapes is key to solving various engineering problems. However, simulating flow physics across complex geometries remains numerically challenging and computationally resource-intensive, particularly when using conventional PDE solvers. Machine learning methods offer attractive opportunities to create fast and adaptable PDE solvers. However, benchmark datasets to measure the performance of such methods are scarce, especially for flow physics across complex geometries. 
                <br /><br />
                We introduce FlowBench, a benchmark for neural simulators with over 10K samples, which is larger than any publicly available flow physics dataset. FlowBench contains flow simulation data across complex geometries (parametric vs. non-parametric), spanning a range of flow conditions (Reynolds number and Grashoff number), capturing a diverse array of flow phenomena (steady vs. transient; forced vs. free convection), and for both 2D and 3D. FlowBench contains over 10,000 data samples, with each sample the outcome of a fully resolved, direct numerical simulation using a well-validated simulator framework designed for modeling transport phenomena in complex geometries. For each sample, we include velocity, pressure, and temperature field data at 3 different resolutions and several summary statistics features of engineering relevance (such as coefficients of lift and drag, and Nusselt numbers). 

                We envision that FlowBench will enable evaluating the interplay between complex geometry, coupled flow phenomena, and data sufficiency on the performance of current, and future, neural PDE solvers. We enumerate several evaluation metrics to help rank order the performance of current (and future) neural PDE solvers. We benchmark the performance of three baseline methods: Fourier Neural Operators (FNO), Convolutional Neural Operators (CNO), and DeepONets. This dataset will be a valuable resource for evaluating neural PDE solvers that model complex fluid dynamics around 2D and 3D objects. 
              </p>
            </div>
            <div style={{ marginTop: "2rem", textAlign: "left" }}>
              {/* <h2 style={{ textAlign: 'center',fontSize: "1.5rem", marginBottom: "1rem" }}>How to Use the Dataset?</h2>
              <div>
                <label htmlFor="datasetSelect" style={{ fontSize: "1rem" }}>Select Dataset:</label>
                <select id="datasetSelect" value={selectedDataset} onChange={handleDatasetChange} style={{ marginLeft: "1rem" }}>
                  <option value="">--Select Dataset--</option>
                  {Object.keys(datasets).map((key) => (
                    <option key={key} value={key}>{key}</option>
                  ))}
                </select>
              </div> */}
              <p style={{ fontSize: "1rem", textAlign: "justify", marginTop: "1rem" }}>{description}</p>
              {selectedDataset && (
                <div>
                  {/* <h4 style={{ fontWeight: "normal" }}>Metadata:</h4> */}
                  <br></br>
                  <ul style={{ fontSize: "1rem", textAlign: "justify" }}>
                    {Object.entries(metadata).map(([key, value]) => (
                      <li key={key}><strong>{key.charAt(0).toUpperCase() + key.slice(1)}:</strong> {value}</li>
                    ))}
                  </ul>
                </div>
              )}
              {/* <p style={{ fontSize: "1rem", textAlign: "justify", marginTop: "1rem" }}>
                Download the dataset, use the following command:
              </p> */}
              {/* <div style={{ backgroundColor: "#f0f0f0", padding: "1rem", borderRadius: "0.5rem", fontFamily: "monospace" }}>
                wget https://figshare.com/s/15e9d23790d0a14e8f71/{selectedDataset}.npz
              </div>
              <br /> */}
              {/* <p style={{ fontSize: "1rem", textAlign: "justify" }}>
                To load a dataset sample using numpy, use the following command:
              </p> */}
              {/* <div style={{ backgroundColor: "#f0f0f0", padding: "1rem", borderRadius: "0.5rem", fontFamily: "monospace" }}>
                import numpy as np<br />
                data = np.load('path_to_data_sample.npz')<br />
              </div> */}
            </div>

            <div>
              <span className="greeting-designation"></span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;

// import React, { useState } from "react";

// import gh from "../assets/social_media/gh.png";
// import paper from "../assets/social_media/paper.png";
// import dataset from "../assets/social_media/datasets_logo.png";
// import streams from "../assets/gifs/streamlines.gif";
// import nsht from "../assets/gifs/animated_case100.gif";
// import poster from "../assets/poster/Poster.png";
// import fpo from "../assets/gifs/animated_slices.gif";

// function About() {
//   const [selectedDataset, setSelectedDataset] = useState("");
//   const [description, setDescription] = useState("");
//   const [metadata, setMetadata] = useState({});

//   const datasets = {
//     "LDC_2D": "2D LDC dataset",
//     "LDC_3D": "3D LDC dataset",
//   };

//   const metadataInfo = {
//     "LDC_2D": {
//       description: "2D LDC dataset",
//       size: "500 MB",
//       samples: "2000",
//       resolution: "128x128",
//       variables: "u,p,v,T"
//     },
//     "LDC_3D": {
//       description: "3D LDC dataset",
//       size: "1 GB",
//       samples: "2000",
//       resolution: "256x256",
//       variables: "u,p,v,T"
//     },
//   };

//   const handleDatasetChange = (e) => {
//     const datasetName = e.target.value;
//     setSelectedDataset(datasetName);
//     setDescription(datasets[datasetName] || "");
//     setMetadata(metadataInfo[datasetName] || {});
//   };

//   return (
//     <section className="pt-2">
//       <div className="container">
//         <div className="row">
//           <div className="col-md-12 text-center">
//             <div style={{ backgroundColor: "#e0e0e0", color: "#000", padding: "1rem", borderRadius: "0.5rem" }}>
//               <span className="greeting" style={{ fontSize: "2rem" }}>Abstract</span>
//               <p style={{ color: "#540", fontSize: "0.9rem", textAlign: "justify", textAlignLast: "center" }}>
//                 Simulating fluid flow around arbitrary shapes is key to solving various engineering problems. However, simulating flow physics across complex geometries remains numerically challenging and computationally resource-intensive, particularly when using conventional PDE solvers. Machine learning methods offer attractive opportunities to create fast and adaptable PDE solvers. However, benchmark datasets to measure the performance of such methods are scarce, especially for flow physics across complex geometries. 
//                 <br /><br />
//                 We introduce FlowBench, a benchmark for neural simulators with over 10K samples, which is larger than any publicly available flow physics dataset. FlowBench contains flow simulation data across complex geometries (parametric vs. non-parametric), spanning a range of flow conditions (Reynolds number and Grashoff number), capturing a diverse array of flow phenomena (steady vs. transient; forced vs. free convection), and for both 2D and 3D. FlowBench contains over 10,000 data samples, with each sample the outcome of a fully resolved, direct numerical simulation using a well-validated simulator framework designed for modeling transport phenomena in complex geometries. For each sample, we include velocity, pressure, and temperature field data at 3 different resolutions and several summary statistics features of engineering relevance (such as coefficients of lift and drag, and Nusselt numbers). 

//                 We envision that FlowBench will enable evaluating the interplay between complex geometry, coupled flow phenomena, and data sufficiency on the performance of current, and future, neural PDE solvers. We enumerate several evaluation metrics to help rank order the performance of current (and future) neural PDE solvers. We benchmark the performance of three baseline methods: Fourier Neural Operators (FNO), Convolutional Neural Operators (CNO), and DeepONets. This dataset will be a valuable resource for evaluating neural PDE solvers that model complex fluid dynamics around 2D and 3D objects. 
//               </p>
//             </div>
//             <div style={{ marginTop: "2rem", textAlign: "left" }}>
//               <h2 style={{ textAlign: 'center',fontSize: "1.5rem", marginBottom: "1rem" }}>How to Use the Dataset?</h2>
//               <div>
//                 <label htmlFor="datasetSelect" style={{ fontSize: "1rem" }}>Select Dataset:</label>
//                 <select id="datasetSelect" value={selectedDataset} onChange={handleDatasetChange} style={{ marginLeft: "1rem" }}>
//                   <option value="">--Select Dataset--</option>
//                   {Object.keys(datasets).map((key) => (
//                     <option key={key} value={key}>{key}</option>
//                   ))}
//                 </select>
//               </div>
//               {/* <p style={{ fontSize: "1rem", textAlign: "justify", marginTop: "1rem" }}>{description}</p> */}
//               {selectedDataset && (
//                 <div>
//                   {/* <h4 style={{ fontWeight: "normal" }}>Metadata:</h4> */}
//                   <br></br>
//                   <ul style={{ fontSize: "1rem", textAlign: "justify" }}>
//                     {Object.entries(metadata).map(([key, value]) => (
//                       <li key={key}><strong>{key.charAt(0).toUpperCase() + key.slice(1)}:</strong> {value}</li>
//                     ))}
//                   </ul>
//                 </div>
//               )}
//               <p style={{ fontSize: "1rem", textAlign: "justify", marginTop: "1rem" }}>
//                 Download the dataset, use the following command:
//               </p>
//               <div style={{ backgroundColor: "#f0f0f0", padding: "1rem", borderRadius: "0.5rem", fontFamily: "monospace" }}>
//                 wget https://figshare.com/s/15e9d23790d0a14e8f71/{selectedDataset}.npz
//               </div>
//               <br />
//               <p style={{ fontSize: "1rem", textAlign: "justify" }}>
//                 To load a dataset sample using numpy, use the following command:
//               </p>
//               <div style={{ backgroundColor: "#f0f0f0", padding: "1rem", borderRadius: "0.5rem", fontFamily: "monospace" }}>
//                 import numpy as np<br />
//                 data = np.load('path_to_data_sample.npz')<br />
//               </div>
//             </div>

//             <div style={{ marginTop: "2rem" }}>
//               <h2 style={{ fontSize: "1.5rem", marginBottom: "1rem" }}>Visualization of Complex Physics and Geometries in FlowBench</h2>
//               <img src={nsht} alt="GIF" style={{ maxWidth: "80%", marginTop: "1rem" }} />
//               <p style={{ textAlign: 'center', fontStyle: 'italic' }}>Variation of Shapes and Grashoff Number in FlowBench</p>
//               <br /><br />
//               <img src={streams} alt="GIF" style={{ maxWidth: "80%", marginTop: "1rem" }} />
//               <p style={{ textAlign: 'center', fontStyle: 'italic' }}>Variation of Shapes and Reynolds Number in FlowBench</p>
//               <br /><br />
//               <img src={fpo} alt="GIF" style={{ maxWidth: "80%", marginTop: "1rem" }} />
//               <p style={{ textAlign: 'center', fontStyle: 'italic' }}>Flow passing through complex geometries</p>
//               <br /><br />
//             </div>

//             <div>
//               <span className="greeting-designation"></span>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// export default About;
